import EventEmitter from 'events';

EventEmitter.defaultMaxListeners = 50;
EventEmitter.prototype.setMaxListeners(50);
